import React, { useEffect, useState } from "react";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TabsList from "../../components/Tabs/Tabs";
import { setCurrentActiveTab } from "../../state/actions/PersonalDetailsActions";
import RegThirdStep from "../Register/RegThirdStep/RegThirdStep";
// import arrowleft from "../../assets/images/arrow-left-black.png";
import SalaryData from "../../entities/SalaryData";
import { GetSalaryData } from "../../services/GetSalaryData";
import MemberData from "../../entities/MemberData";

import "./PersonalDetails.scss";
import { GetMemberDetails } from "../../services/GetMemberDetails";
import CircleLoading from "../../components/CircleLoading/CircleLoading";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";

const PersonalDetails = () => {  
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("common");
  const [loading, setLoading] = useState<boolean>(false);
  const currentActiveTab = useSelector(
    (state: any) => state.PersonalDetailsReducer.currentActiveTab
  );
  const [userSalaryData, setSalaryData] = useState<SalaryData>(
    {} as SalaryData
  );
  const [memberDetails, setMemberDetails] = useState<MemberData>(
    {} as MemberData
  );

  const [value, setValue] = React.useState(`${t('personalDetails.personal')}`);

  const handleChange = (event: any, newValue: string) => {
    setValue(newValue);
    dispatch(setCurrentActiveTab(newValue))
  };

  const { userId, isAmit, isPensioner, firstName, lastName } = useSelector(
    (state: any) => state.UserReducer
  );

  const getTabsLabelsByUserType = () => {
    if ((isAmit && isPensioner) || isPensioner) {
      return [t("personalDetails.personal"), t("personalDetails.bankData")];
    } else if (isAmit) {
      return [t("personalDetails.personal")];
    }
    return [];
  };
  const tabLabels: string[] = getTabsLabelsByUserType();

  const initPensionerData = async () => {
    const salaryData = await GetSalaryData();
    if (salaryData && salaryData.length) {
      setSalaryData(salaryData[0]);
    }
  };

  useEffect(() => {
    document.title = "amitim " +  t("personalDetails.personal");
  }, []);

  useEffect(() => {
    async function init() {
      !currentActiveTab.length &&
        dispatch(setCurrentActiveTab(t("personalDetails.personal")));
      await GetMemberDetails().then((res)=>{
        setMemberDetails(res);
      })
      
      if ((isAmit && isPensioner) || isPensioner) {
        initPensionerData().then((res)=>{
          setLoading(false);
        })
      }
      
    }
    init();
    return () => {
      dispatch(setCurrentActiveTab(""));
    };
    // eslint-disable-next-line
  }, []);

  useDidMountEffect(() => {
    dispatch(setCurrentActiveTab(t("personalDetails.personal")));
  }, [i18n.language]);

  return (
    <main id="main" className="page content personal-details">
      <div className="he-pg-ca">
      <h1>{t("personalDetails.personal")}</h1>
      </div>
      <TabContext  value={value} >
      <div id="personal-details-wrap-details" className="wrap-details">
        <TabsList
          labels={tabLabels}
          currentActiveTab={currentActiveTab}
          setCurrentActiveTab={setCurrentActiveTab}
          handleChange={handleChange}
        />
        <div className="personal-details-container">
          {loading ? (
            <CircleLoading />
          ) : currentActiveTab === t("personalDetails.personal") ? (
            <TabPanel sx={{padding: "0px"}} value={t('personalDetails.personal')} id={`tabpanel-${t("personalDetails.personal")}`} role="tabpanel" aria-labelledby={`tab-${t("personalDetails.personal")}`}>
              <RegThirdStep
                fromPersonalDetails={true}
                memberDetails={memberDetails}
              />
            </TabPanel>
          ) : (
            <>
              <div className="third-user-details-wrapper" tabIndex={0}>
                <div className="third-user-detail">
                  <span className="third-user-detail-title">
                    {t("personalDetails.fullName")}
                  </span>
                  <span className="third-user-detail-label">{`${firstName} ${lastName}`}</span>
                </div>
                <div className="third-user-detail">
                  <span className="third-user-detail-title">
                    {t("personalDetails.bankName")}
                  </span>
                  <span className="third-user-detail-label">
                    {userSalaryData?.bankDescription}
                  </span>
                </div>
                <div className="third-user-detail">
                  <span className="third-user-detail-title">
                    {t("personalDetails.bankCode")}
                  </span>
                  <span className="third-user-detail-label">
                    {userSalaryData?.branchCode}
                  </span>
                </div>
                <div className="third-user-detail">
                  <span className="third-user-detail-title">
                    {t("personalDetails.bankNumber")}
                  </span>
                  <span className="third-user-detail-label">
                    {userSalaryData?.bankAcountno?.trim()}
                  </span>
                </div>
              </div>

              {/* Update bank account button */}
              {/* <div className="d-flex align-items-center justify-content-center"> up
                <button
                  type="submit"
                  className="third-step-button"
                  //   disabled={submitLoading}
                  style={{
                    width: "initial",
                    marginBottom: 40,
                    marginTop: 10,
                    padding: "8px 16px",
                  }}
                >
                  <span style={{ fontSize: 18 }}>{`${t(
                    "personalDetails.updateBankData"
                  )}`}</span>
                  <img src={arrowleft} alt="" />
                </button>
              </div> */}
            </>
          )}
        </div>
      </div>
      </TabContext>
    </main>
  );
};

export default PersonalDetails;
